export default {"src":"/_next/static/media/lune-icon-validation.3edf32c1.svg","height":144,"width":144,"blurWidth":0,"blurHeight":0};